import { ContentType } from "@authory-packages/core";
import { V3IconArticle, V3IconBook, V3IconImage, V3IconPDF, V3IconPodcast, V3IconPost, V3IconVideo, V3IconWebsiteEmail } from "../components/Icons";
import React from "react";

export const V3COMBINED_POST_TYPE = `${ContentType.TextPost}$${ContentType.ReplyPost}$${ContentType.Thread}$${ContentType.VideoPost}$${ContentType.ImagePost}`;
export const V3COMBINED_WEBSITE_EMAIL_TYPE = `${ContentType.Website}$${ContentType.Email}`;
export const V3COMBINED_AUDIO_TYPE = `${ContentType.PodcastItem}$${ContentType.Audio}`;

export const FORMATED_SOURCE_TYPES: {
    value: string;
    text: string;
    icon: React.FC;
}[] = [
    { value: ContentType.Article, text: "Articles", icon: V3IconArticle },
    { value: V3COMBINED_AUDIO_TYPE, text: "Podcasts & Audios", icon: V3IconPodcast },
    { value: ContentType.Video, text: "Videos", icon: V3IconVideo },
    { value: V3COMBINED_POST_TYPE, text: "Social Media", icon: V3IconPost },
    { value: V3COMBINED_WEBSITE_EMAIL_TYPE, text: "Websites/Emails", icon: V3IconWebsiteEmail },
    { value: ContentType.PdfFile, text: "PDFs", icon: V3IconPDF },
    { value: ContentType.Image, text: "Image", icon: V3IconImage },
    { value: ContentType.Book, text: "Books", icon: V3IconBook }
];
